export class MenuItem {
    public icon!: string;
    public icon_fntaws!: string;
    public text!: string;
    public color!: string;
    public link!: string;
    public permission!: string;
    public children: MenuItem[] = [];
}
